export default "__VITE_ASSET__ed0cbd28__"